var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 7.52284C30.8311 7.81664 30.8311 8.10328 30.8311 8.41858C30.8311 17.591 23.8745 28.1822 11.1326 28.1822C7.21152 28.1822 3.57608 27.0428 0.490601 25.065C1.04056 25.1152 1.59766 25.1725 2.14762 25.1725C5.39023 25.1725 8.39 24.0618 10.7612 22.1843C7.73291 22.1342 5.17596 20.1205 4.28317 17.3473C4.70457 17.4261 5.15453 17.4763 5.59735 17.4763C6.22588 17.4763 6.83297 17.3975 7.4115 17.2398C4.24746 16.6021 1.85478 13.7787 1.85478 10.425V10.3175C2.82614 10.8693 3.8832 11.1631 4.99026 11.1918C3.14754 9.95209 1.91192 7.83814 1.91192 5.40173C1.91192 4.13336 2.25476 2.94382 2.86185 1.91192C6.28302 6.11115 11.3683 8.89153 17.1393 9.17817C17.0322 8.67655 16.9536 8.14627 16.9536 7.5945C16.9536 3.76073 20.0605 0.643555 23.8817 0.643555C25.8815 0.643555 27.6742 1.48913 28.9384 2.83633C30.4954 2.52103 31.9953 1.96208 33.3381 1.14517C32.8381 2.78616 31.7311 4.13336 30.3097 5.00043C31.7025 4.81412 33.0453 4.44866 34.288 3.88972C33.3309 5.3014 32.1667 6.51244 30.8026 7.52284Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1bd91de3da6374e43ec32b6da8bcbe8a.svg";
export { ForwardRef as ReactComponent };